import React from "react";
import CrudManager from "./CrudManager";

export default function NewsManager() {
    return (
        <CrudManager
            testId="admin-news"
            resource="/admin/news"
            title="Noticias"
            idField="id"
            columns={[
                { key: "title", label: "Título" },
                { key: "slug", label: "Slug" },
                { key: "published", label: "Publicada" },
            ]}
            fields={[
                { name: "title", label: "Título", required: true },
                { name: "excerpt", label: "Resumen", type: "textarea", rows: 2, required: true },
                { name: "content", label: "Contenido", type: "textarea", rows: 8, required: true },
                { name: "cover_image", label: "URL imagen de portada" },
                { name: "published", label: "Estado", type: "checkbox", placeholder: "Publicada" },
            ]}
            defaultValues={{ title: "", excerpt: "", content: "", cover_image: "", published: true }}
        />
    );
}
